import { render, staticRenderFns } from "./article.vue?vue&type=template&id=9f671ab8&scoped=true"
import script from "./article.vue?vue&type=script&lang=js"
export * from "./article.vue?vue&type=script&lang=js"
import style0 from "../assets/css/article.scss?vue&type=style&index=0&id=9f671ab8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f671ab8",
  null
  
)

export default component.exports